import { render } from "./PromptManagement.vue?vue&type=template&id=04958bf8&scoped=true"
import script from "./PromptManagement.vue?vue&type=script&lang=js"
export * from "./PromptManagement.vue?vue&type=script&lang=js"

import "./PromptManagement.vue?vue&type=style&index=0&id=04958bf8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04958bf8"]])

export default __exports__